export default __webpack_public_path__ + "static/media/emoji.c7a39969.svg";